/* istanbul ignore file - need to fix flakey tests */
import { Stack } from '@mui/material';
import { PartsCategoriesProvider } from '../../lib/context/PartsCategoriesContext';
import { PartsCategoriesDataTable } from './PartsCategoriesDataTable';

interface PartCategoriesInteractiveTableProps {
  configurationPID: string;
}

export function PartsCategoriesInteractiveTable({ configurationPID }: PartCategoriesInteractiveTableProps) {
  return (
    <PartsCategoriesProvider configurationPID={configurationPID}>
      <Stack gap={2} direction="column">
        <PartsCategoriesDataTable />
      </Stack>
    </PartsCategoriesProvider>
  );
}
